import React, { useState, useEffect } from "react";

// common function
import { rainStationLatLon } from "../scripts/station";
import { rainfallMarker } from "../scripts/rainfallMarker";
import { fetchingTime } from "../../../../config/fetching";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/hourlyRainfallMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
  useMapEvents,
} from "react-leaflet";
// L component
import Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

import { getRainfallInformation } from "../../../service/apiHKOWeatherInfoService";
// import data from '../../../../resources/rainfall_pasthour.json'

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type rainfallnfo_Props = {
  automaticWeatherStation: string;
  value: string;
};

function HourlyRainfallMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [rainfallArray, setRainfallArray] = useState<Array<rainfallnfo_Props>>(
    []
  );
  const [time, setTime] = useState<string>("");

  const [zoomLevel, setZoomLevel] = useState<number>(11);

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  // zoom change
  const ZoomListener = () => {
    useMapEvents({
      zoomend: (event) => {
        const map = event.target;
        const zoom = map.getZoom();

        setZoomLevel(zoom);
      },
    });
    return null;
  };

  async function getRainInfomation() {
    await getRainfallInformation()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        setRainfallArray(data.hourlyRainfall);
        setTime(data.obsTime);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getRainInfomation();
      }
    };

    getRainInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);

    // Reset the zoom level
    setZoomLevel(11);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        <ZoomListener />

        {rainfallArray.map((item) => {
          if (
            (item.automaticWeatherStation === "King’s Park" ||
              item.automaticWeatherStation === "Magazine Gap" ||
              item.automaticWeatherStation === "Kai Tak" ||
              item.automaticWeatherStation === "Broadcast Drive") &&
            zoomLevel === 11
          ) {
            return null;
          } else {
            return (
              <Marker
                key={"rainfall-" + item.automaticWeatherStation}
                position={rainStationLatLon(item.automaticWeatherStation)}
                icon={rainfallMarker(item.value)}
              />
            );
          }
        })}
      </MapContainer>

      <div className="mapDescription">
        <div>過去1小時雨量(mm/h)</div>
        <div>
          {time.substr(5, 2)}月{time.substr(8, 2)}日 {time.substr(11, 2)}:
          {time.substr(14, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default HourlyRainfallMap;
